/* global axios */
import React, { useState, useEffect } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

function ServiceMarkerForm() {
  const [selectedDate, setSelectedDate] = useState(() => {
    const heute = new Date();
    const yyyy = heute.getFullYear();
    const mm = String(heute.getMonth() + 1).padStart(2, '0');
    const dd = String(heute.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`; // default = heute
  });
  const [markers, setMarkers] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Beim initialen Render und bei jeder Datum-Änderung JSON-Daten laden
  useEffect(() => {
    const fetchMarkers = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await api.get('/servicemarkers/dailyPlanningForm', {
          params: { date: selectedDate }
        });
        setMarkers(response.data.serviceMarkers);
      } catch (err) {
        console.error('Fehler beim Laden der ServiceMarker:', err);
        setError('Daten konnten nicht geladen werden.');
        setMarkers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMarkers();
  }, [selectedDate]);

 // PDF-Download
  const handleDownloadPDF = () => {
    if (!selectedDate) {
      setError('Bitte ein Datum auswählen!');
      return;
    }

    // hier holen wir uns einfach die Base-URL, die in apiService hinterlegt ist:
    const baseURL = api.defaults.baseURL; // z.B. "http://localhost:3001"
    const url = `${baseURL}/servicemarkers/dailyPlanningReport/pdf?date=${selectedDate}`;
    window.open(url, '_blank');
  };

  // Formular absenden (Verhindern, weil wir OnChange nutzen)
  const handleSubmit = (e) => {
    e.preventDefault();
    // Der JSON-Request wird bereits per useEffect nachvollzogen
  };

  return (
    <div style={{ maxWidth: '800px', margin: 'auto' }}>
      <Helmet>
        <title>ServiceMarker-Bericht</title>
        <meta name="description" content="ServiceMarker-Bericht" />
      </Helmet>

      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>
        Selbstabholerliste
      </h2>
      
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' }}>
          <label>
            &nbsp;
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              style={{ marginTop:'0px', padding: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </label>
          <button
            type="button"
            onClick={handleDownloadPDF}
            style={{
              marginLeft: '20px',
              padding: '6px 12px',
              background: '#007bff',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop:'3px',
            }}
          >
            PDF herunterladen
          </button>
        </div>
      </form>

      {error && <p style={{ color: 'red' }}>{error}</p>}
      {loading && <p>Lade ServiceMarker-Daten…</p>}

      {!loading && markers.length === 0 && (
        <p>Für den {new Date(selectedDate).toLocaleDateString('de-DE')} wurden keine Einträge gefunden.</p>
      )}

      {!loading && markers.length > 0 && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f0f0f0' }}>
                <th style={{ padding: '8px', border: '1px solid #ddd' }}>ID</th>
                <th style={{ padding: '8px', border: '1px solid #ddd' }}>Order-Nr.</th>
                <th style={{ padding: '8px', border: '1px solid #ddd' }}>Kunde</th>
                <th style={{ padding: '8px', border: '1px solid #ddd' }}>Artikel</th>
                <th style={{ padding: '8px', border: '1px solid #ddd' }}>Art</th>
                <th style={{ padding: '8px', border: '1px solid #ddd' }}>Datum</th>
                <th style={{ padding: '8px', border: '1px solid #ddd' }}>Zeit</th>
                <th style={{ padding: '8px', border: '1px solid #ddd' }}>Ort</th>
                <th style={{ padding: '8px', border: '1px solid #ddd' }}>Notizen</th>
              </tr>
            </thead>
            <tbody>
              {markers.map(marker => (
                <tr key={marker.id}>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>{marker.id}</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                    {marker.orderItem.order.orderNumber}
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                    {marker.orderItem.order.customer.company}
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                    {marker.orderItem.item.name}
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                    {marker.relevantDateType}
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                    {new Date(marker.relevantDate).toLocaleDateString('de-DE')}
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
  {(() => {
  const t = marker.relevantTime;
  if (!t) return '-';

  // 1) Parsen als Date-Objekt versuchen
  const dt = new Date(t);
  if (!isNaN(dt)) {
    // Wenn gültiges Datum, gib es formatiert aus
    return dt.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
  }

  // 2) Wenn ungültig, erwarte Format "HH:MM:SS" oder ähnliches
  //    und schneide nur die ersten 5 Zeichen "HH:MM" raus
  return t.length >= 5 ? t.slice(0, 5) : t;
})()}
</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                    {marker.operationLocation || '-'}
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                    {marker.serviceNotes || '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ServiceMarkerForm;
